import React, { useState } from 'react';

export const useSelectedListingMarker = (feature: any, selectedList?: any) => {
  const [isTure, setIsTrue] = useState(false);
  if (selectedList.length >= 1) {
    setIsTrue(selectedList.some((item: any) => item.mls_id === feature.mls_id));
  }
  return isTure;
};
